export const COLORS = [
  '#ff6b2b', '#4ecdc4', '#ff85a1', '#a78bfa', '#fbbf24',
  '#34d399', '#f87171', '#60a5fa', '#c084fc', '#fb923c',
  '#2dd4bf', '#e879f9',
] as const;

export function colorFromName(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) - hash + name.charCodeAt(i)) | 0;
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}
